<template>
  <SheetContainer title="别名" desc="长按最多选中10个字符，设置别名">
    <div class="alias-sheet">
      <div class="alias-form">
        <div class="alias-input" @click="onInputClick">
          <span>{{ aliasContent }}</span>
        </div>
        <div class="btn" :class="{ removable }" @click="onRemove">移除</div>
      </div>

      <div v-if="false" class="batch-btn">批量设置别名</div>
    </div>

    <!-- 别名输入 -->
    <InputModal
      title="设置别名"
      placeholder="请输入别名"
      :defaultValue="aliasContent"
      type="text"
      :visible.sync="inputVisible"
      @confirm="onConfirmInput"
    />
  </SheetContainer>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import InputModal from "@/components/input-modal/input-modal.vue";
import { toast } from "@/utils/util";
import $ from "jquery";
import { isEqual } from "lodash-es";

export default {
  components: {
    SheetContainer,
    InputModal,
  },
  props: {
    sheetVisible: {
      type: Boolean,
      default: false,
    },
    value: {
      // 选中值信息
      type: [String, Object],
      default: "",
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedValue: "", // 当前选中的值，未选中或者清除时值为""
      inputVisible: false,

      aliasContent: "",
    };
  },

  computed: {
    removable() {
      return this.selectedValue;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: "init",
    },
    sheetVisible: {
      immediate: true,
      handler: "init",
    },
  },
  methods: {
    init() {
      if (this.sheetVisible) {
        this.selectedValue = this.value;
        const { aliasContent = "" } = this.selectedValue || {};
        this.aliasContent = aliasContent;
      }
    },
    // 校验选中是否合法

    isValid() {
      if (this.selection.el) {
        if ($(this.selection.el).attr("data-type") !== "aliasChange") {
          toast("请选中10个字以内的文本");
          return false;
        }
        return true;
      }
      if (!this.selection.rangeText || !this.selection.rangeText.trim()) {
        toast("请选中10个字以内的文本");
        return false;
      }
      if (this.selection.rangeText.length > 10) {
        toast("请选中10个字以内的文本");
        return false;
      }
      const $editor = this.$parent;
      const effects = {
        1: "multi-tone", // 多音字
        19: "stress", // 重音
        8: "pause", //停顿
        9: "mute", // 静音
        3: "liandu", // 连读
        6: "localSpeed", // 局部变速
        12: "globalMute", //段落静音
        7: "multiSpeaker", //多发音人
        4: "aliasChange", //别名
      };
      if (
        $editor.hasEffectRange(this.selection.range, Object.values(effects))
      ) {
        toast("别名暂不支持与当前功能组合使用");
        return false;
      }

      // 多发音人特效支持检查
      const speakerNotSupport = $editor.isRangeSpeakerNotSupportEffect(
        this.selection.range,
        "aliasChage"
      );
      if (speakerNotSupport) {
        toast(`${speakerNotSupport.name.split("|")[0]}暂不支持别名`);
        return false;
      }
      return true;
    },
    onInputClick() {
      // if (!this.isValid()) return;
      this.inputVisible = true;
    },
    //插入/修改多发音人
    onConfirmInput(aliasContent) {
      this.aliasContent = aliasContent;
      const aliasContent2 = "//" + aliasContent;
      let speedhover = $(this.selection.el).attr("data-aliasGroupKey");
      if (speedhover) {
        let effectParam = {
          effectName: "aliasChange",
          idName: "aliasGroupKey",
          id: speedhover,
          innerEffectName: "aliasChangeInner",
        };
        this.$emit("updateNode", effectParam, {
          aliasContent,
          aliasContent2,
        });
      } else {
        this.updateValue({
          aliasContent,
          aliasContent2,
        });
      }
    },
    // 删除多发音人
    onRemove() {
      let speedhover = $(this.selection.el).attr("data-aliasGroupKey");
      let effectParam = {
        effectName: "aliasChange",
        idName: "aliasGroupKey",
        id: speedhover,
        innerEffectName: "aliasChangeInner",
      };
      this.aliasContent = "";
      this.$emit("updateNode", effectParam, {}, "delete");
    },
    // 更新多发音人
    updateValue(newValue) {
      if (!isEqual(newValue, this.selectedValue)) {
        this.selectedValue = newValue;
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.alias-sheet {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alias-form {
  display: flex;
  margin-bottom: 40px;
  .alias-input {
    box-sizing: border-box;
    padding: 10px 24px;
    margin-right: 28px;
    display: flex;
    align-items: center;
    flex: 1;
    min-height: 64px;
    border-radius: 10px;
    border: 2px solid #cedcef;
    font-size: 26px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 400;
    color: #b8b8b8;

    span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 210px;
  height: 64px;
  background: #f4f4f4;
  border-radius: 10px;
  font-size: 26px;
  font-family: 'HarmonyOS_Sans_SC';
  font-weight: 400;
  color: #b8b8b8;

  &.active {
    background: #3583fb;
    color: #fff;
  }

  &.removable {
    background: #dceafe;
    color: #333333;
  }
}

.batch-btn {
  margin-bottom: 8px;
  margin-top: auto;
  font-size: 28px;
  font-family: 'HarmonyOS_Sans_SC';
  font-weight: 500;
  color: #3583fb;
  line-height: 40px;
}
</style>